import { HoverCard, createStyles, rem } from '@mantine/core';

export const useCartStyle = createStyles((theme) => ({
  addressStyle: {
    gap: 4,
    fontSize: 11,
  },
  web_addressStyle: {
    gap: 4,
    fontSize: 13,
  },
  item: {
    transition: 'transform 150ms ease',

    '&[data-active]': {
      backgroundColor: 'transparent',
      borderRadius: theme.radius.md,
      zIndex: 1,
    },
  },
  chevron: {
    color: '#FA9418',
  },
  content: {
    padding: 0,
  },
  addsOnTable: {
    paddingLeft: '0',
    paddingBottom: '0',
    paddingTop: '0',
  },
  label: {
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  couponInput: {
    // background: '#FFFFFF',
    borderRadius: '10px',
    input: {
      border: '1px solid #7E7E7E',
      fontWeight: 500,
    },
    'input:: placeholder': {
      fontSize: '12px',
      fontWeight: 500,
      color: '#7E7E7E',
    },
    label: {
      fontSize: '11px',
      color: '#D61D4F',
      fontWeight: 450,
    },
  },
  couponInputWeb: {
    // background: '#FFFFFF',
    borderRadius: '10px',
    input: {
      border: '1px solid #7E7E7E',
      fontSize: '15px',
    },
    'input:: placeholder': {
      fontSize: '15px',
      fontWeight: 500,
      color: '#7E7E7E',
    },
    label: {
      fontSize: '14px',
      color: '#D61D4F',
      fontWeight: 400,
    },
  },
  stickyPosition: {
    padding: '5px',
    borderRadius: '3px',
    // margin: '1em 0',
    position: 'sticky',
    top: '0',
  },
  checkoutButtonSticky: {
    padding: '5px',
    position: 'sticky',
    top: 0,
    bottom: 0,
  },
}));

export const useCartStyles = createStyles((theme) => ({
  title: {
    fontWeight: 500,
    fontSize: 18,
    lineHeight: 1,
    color: 'white',
  },

  restaurantNameText: {
    color: theme.colors.magenta[9],
    fontWeight: 500,
    fontSize: 20,
    lineHeight: 1,
  },

  restaurantLocationFlexContainer: {
    marginTop: 12,
    display: 'flex',
    gap: 8,
  },

  restaurantAddressText: {
    fontSize: 14,
    lineHeight: 1,
    fontWeight: 450,
  },

  addOnsText: {
    fontSize: 14,
    lineHeight: 1,
    fontWeight: 500,
    color: theme.colors.magenta[9],
  },

  mainFoodItemText: {
    lineHeight: 1,
    fontWeight: 500,
    fontSize: 18,

    [theme.fn.smallerThan('sm')]: {
      fontSize: 13,
    },
  },

  extraFoodItemText: {
    lineHeight: 1,
    fontWeight: 500,
    fontSize: 14,

    [theme.fn.smallerThan('sm')]: {
      fontSize: 12,
    },
  },

  table: {
    th: {
      borderBottom: '1px solid #7e7e7e !important',
      padding: `${rem(8)} ${rem(4)} !important`,

      ':nth-of-type(1)': {
        width: '5%',
      },

      ':nth-of-type(2)': {
        width: '50%',
      },

      ':nth-of-type(3)': {
        width: '15%',
        textAlign: 'center',
      },

      ':nth-of-type(4)': {
        width: '30%',
        textAlign: 'center',
      },

      [theme.fn.smallerThan('sm')]: {
        fontSize: `${rem(11)} !important`,

        ':nth-of-type(1)': {
          width: '5%',
        },

        ':nth-of-type(2)': {
          width: '25%',
        },

        ':nth-of-type(3)': {
          width: '25%',
          textAlign: 'center',
        },

        ':nth-of-type(4)': {
          width: '35%',
          textAlign: 'center',
        },
      },
    },

    'td.addOn': {
      padding: `${rem(0)} 0px !important`,
    },

    td: {
      border: 'none !important',
      padding: `${rem(8)} ${rem(4)} !important`,
      ':nth-of-type(3)': {
        textAlign: 'center',
      },

      ':nth-of-type(4)': {
        textAlign: 'center',
      },
    },
  },

  childTable: {
    thead: {
      th: {
        paddingBlock: `${rem(12)} !important`,
        borderBlock: '1px solid black !important',
      },
    },

    td: {
      // border: '1px solid black',
      // padding: `${rem(8)} ${rem(4)} !important`,

      ':nth-of-type(1)': {
        width: '5%',
      },

      ':nth-of-type(2)': {
        width: '50%',
      },

      ':nth-of-type(3)': {
        width: '15%',
        textAlign: 'center',
      },

      ':nth-of-type(4)': {
        width: '30%',
        textAlign: 'center',
      },

      [theme.fn.smallerThan('sm')]: {
        fontSize: `${rem(11)} !important`,

        ':nth-of-type(1)': {
          width: '5%',
        },

        ':nth-of-type(2)': {
          width: '25%',
        },

        ':nth-of-type(3)': {
          width: '25%',
          textAlign: 'center',
        },

        ':nth-of-type(4)': {
          width: '35%',
          textAlign: 'center',
        },
      },
    },
  },

  notesContainer: {
    display: 'flex',
    boxSizing: 'border-box',
    // border: '1px solid black',
    alignItems: 'center',
  },

  foodItemChangerGenericGridCol: {
    padding: 0,
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    WebkitFlexShrink: 0,
    flexShrink: 0,
    WebkitFlexGrow: 0,
    flexGrow: 0,
    ':-ms-flex-negative': 0,
    ':-ms-flex-positive': 0,
    ':-webkit-box-flex': 0,
  },

  foodItemChangerButtonGridCol: {
    padding: 0,
    margin: 0,
    WebkitFlexBasis: `${(2 / 12) * 100}%`,
    flexBasis: `${(2 / 12) * 100}%`,
    maxWidth: `${(2 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(2 / 12) * 100}%`,
  },

  foodItemNameGridCol: {
    padding: 0,
    margin: 0,
    WebkitFlexBasis: `${(8 / 12) * 100}%`,
    flexBasis: `${(8 / 12) * 100}%`,
    maxWidth: `${(8 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(8 / 12) * 100}%`,
  },

  modalButton: {
    width: 120,
    paddingInline: 24,
    paddingBlock: 12,
    borderRadius: 8,
    color: 'white',
    fontWeight: 600,
    minHeight: 48,
    boxShadow: '0px 5px 12px 0px rgba(0,0,0,0.1)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    ':active': {
      transform: 'translateY(0.0625rem)',
    },

    // ':hover': {
    //   backgroundColor: theme.colors.red[6],
    // },
  },

  noButton: {
    backgroundColor: 'white',
    color: theme.colors.red[7],
    border: `1px solid ${theme.colors.red[6]}`,
  },

  yesButton: {
    backgroundColor: theme.colors.red[6],
  },
}));

export const ModalCloseButton = createStyles(() => ({
  closeButton: {
    'Button svg': {
      stroke: '#FF8C22',
      height: '16px',
      width: '16px',
      strokeWidth: '2px',
    },
  },
}));

export const useCartModalStyle = createStyles((theme) => ({
  item: {
    transition: 'transform 150ms ease',
    '&[data-active]': {
      backgroundColor: 'transparent',
      borderRadius: theme.radius.md,
      zIndex: 1,
    },
  },
  label: {
    padding: '5px 0px 7px 0px',
    color: '#D61D4F',
    fontSize: '11px',
    fontWeight: 500,
  },
  content: {
    padding: '0px 0px 10px 0px',
  },
  chevron: {
    color: '#FA9418',
  },
  title: {
    color: '#D61D4F',
    fontWeight: 500,
  },
  input: {
    fontSize: '12px',
    border: '1px solid #7E7E7E',
    fontWeight: 500,
  },
  close: {
    color: '#FF8C22',
  },
  body: {
    paddingLeft: '20px',
    paddingRight: '20px',
  },
  radioOption: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

export const useWebCartModalStyle = createStyles((theme) => ({
  item: {
    transition: 'transform 150ms ease',
    '&[data-active]': {
      backgroundColor: 'transparent',
      borderRadius: theme.radius.md,
      zIndex: 1,
    },
  },
  label: {
    padding: '5px 0px 7px 0px',
    color: '#D61D4F',
    fontSize: '13px',
    fontWeight: 500,
  },
  content: {
    padding: '0px 0px 10px 0px',
  },
  chevron: {
    color: '#FA9418',
  },
  title: {
    color: '#D61D4F',
    fontWeight: 500,
  },
  input: {
    fontSize: '14px',
    border: '1px solid #7E7E7E',
  },
  close: {
    color: '#FF8C22',
  },
  body: {
    paddingLeft: '20px',
    paddingRight: '20px',
  },
  radioOption: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

export const radioStyle = createStyles((theme) => ({
  label: {
    fontSize: '12px',
  },
  icon: {
    color: theme.colors.orange[6],
  },
}));

export const useCheckoutButtonStyles = createStyles((theme) => ({
  button: {
    width: 240,
    paddingInline: 24,
    paddingBlock: 12,
    borderRadius: 8,
    color: 'white',
    fontWeight: 600,
    minHeight: 48,
    position: 'fixed',
    bottom: '2%',
    left: '50%',
    boxShadow: '0px 5px 12px 0px rgba(0,0,0,0.1)',
    backgroundColor: theme.colors.red[6],
    transform: 'translateX(-50%)',

    ':active': {
      transform: 'translate(-50%, 0.0625rem)',
    },

    ':hover': {
      backgroundColor: theme.colors.red[6],
    },
  },
}));
